class Type {
    static STRING = String;
    static BOOLEAN = Boolean;
    static NUMBER = Number;
    static OBJECT = Object;
    static DATE = Date;
    static REGEXP = RegExp;
    static FUNCTION = Function;
    static ARRAY = Array;
    static NULL = null;
    static UNDEFINED = undefined;

    static is(input, type) {
        if (type == null) {
            if (input === null) return Type.NULL;
            else if (input === undefined) return Type.UNDEFINED;
            else if (input instanceof Array) return Type.ARRAY;
            else if (input instanceof Function)  return Type.FUNCTION;
            else if (input instanceof RegExp) return Type.REGEXP;
            else if (input instanceof Date) return Type.DATE;
            else if (input === true || input === false) return Type.BOOLEAN;
            else return typeof input;
        } else {
            // 效率会有点问题
            return Type.is(input) === type;
        }
    }
}
export default Type